import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';
import { environment } from '@env/environment';
import { LocalStorageService } from '@app/shared/services/storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class HttpCacheService {
  exactMatchUrls = [
    `${environment.proxyApiURL}/api/lamps`,
    `${environment.proxyApiURL}/api/config`,
    `${environment.proxyApiURL}/datapool/buildingtypes`,
    `${environment.proxyApiURL}/datapool/buildingtypes?wherekeyA1=isActive&wherevalueA1=1`,
    `${environment.proxyApiURL}/api/consumers`,
    `${environment.proxyApiURL}/datapool/heatingtypes`,
    `${environment.proxyApiURL}/api/producers`,
    `${environment.proxyApiURL}/datapool/municipalities?view=viewmunicipalitiesconcise`,
    `${environment.proxyApiURL}/datapool/administrationcollectivities`,
    `${environment.proxyApiURL}/datapool/metertypes`,
    `${environment.proxyApiURL}/datapool/energytypes`,
    `${environment.proxyApiURL}/datapool/damagetypes`,
    `${environment.proxyApiURL}/datapool/permissions`,
    `${environment.proxyApiURL}/datapool/regiontypes`,
    `${environment.proxyApiURL}/datapool/regions`,
  ];

  startsWithUrls = [`${environment.proxyApiURL}/proxy/map`];

  constructor(public localStorageService: LocalStorageService) {}

  public removeCachedUrl(urlToRemove: string) {
    this.localStorageService.removeItem(urlToRemove);
  }

  public get(req: HttpRequest<any>): HttpResponse<any> | undefined {
    const url = req.url;

    const cached = this.localStorageService.getItem(url);
    if (!cached || req.method !== 'GET') {
      return undefined;
    }

    return new HttpResponse(JSON.parse(cached));
  }

  public put(req: HttpRequest<any>, response: HttpResponse<any>): void {
    if (
      req.method !== 'GET' ||
      (this.exactMatchUrls.findIndex((value) => req.url.toLowerCase() === value.toLowerCase()) === -1 &&
        this.startsWithUrls.findIndex((value) => req.url.toLowerCase().indexOf(value.toLowerCase()) >= 0) === -1)
    ) {
      return undefined;
    }

    const url = req.urlWithParams;

    this.localStorageService.setItem(url, JSON.stringify(response));
  }
}
